import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import { getTelLink, getWhatsAppLink } from "../../lib/utils";

export const QuickActions = ({ 
  phone, 
  onCall, 
  whatsappMessage = ""
}) => {
  const handleCallClick = (e) => {
    e.stopPropagation();
    // Open dialer
    window.location.href = getTelLink(phone);
    // Trigger callback for call log modal
    if (onCall) {
      // Small delay to allow dialer to open
      setTimeout(() => onCall(), 500);
    }
  };

  const handleWhatsAppClick = (e) => {
    e.stopPropagation();
    window.open(getWhatsAppLink(phone, whatsappMessage), "_blank");
  };

  return (
    <TooltipProvider>
      <div className="quick-actions" data-testid="quick-actions">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="quick-action-btn text-green-600 hover:text-green-700 hover:bg-green-50"
              onClick={handleCallClick}
              data-testid="call-button"
            >
              <Phone className="w-4 h-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Call</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="quick-action-btn text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50"
              onClick={handleWhatsAppClick}
              data-testid="whatsapp-button"
            >
              <MessageCircle className="w-4 h-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>WhatsApp</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};

export default QuickActions;
